import { render, staticRenderFns } from "./s09.vue?vue&type=template&id=f1d5b3a2"
import script from "./s09.vue?vue&type=script&lang=js"
export * from "./s09.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports